<template>
  <div style="height: 100%">
    <div>
      <v-text-field
        class="mb-2"
        v-model="searchOrganization"
        :loading="loadingOrganization"
        outlined
        placeholder="ชื่อหน่วยงาน"
        prepend-inner-icon="mdi-magnify"
        dense
        hide-details
        clearable
        @input="handleSearchOrganization"
      ></v-text-field>
    </div>

    <ul
      class="pa-0"
      style="
        height: calc(100% - 190px);
        overflow-y: auto;
        border: 1px solid #bdbdbd;
        list-style: none;
      "
    >
      <organization-tree-item
        v-for="organization in organizations"
        :key="organization.organization_uuid"
        :organization="organization"
        :loadingOrganization="loadingOrganization"
        :handleSelectedOrganization="handleSelectedOrganization"
      />
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import OrganizationTreeItem from '@/components/OrganizationTreeItem.vue'

export default {
  components: {
    OrganizationTreeItem,
  },
  data() {
    return {
      searchOrganization: '',
      loadingOrganization: false,
      selectedOrganizations: [],
      organizations: [],
    }
  },
  async created() {
    try {
      this.loadingOrganization = true

      const { company_uuid } = this.$store.state.authentication.company

      const organizations = await this.fetchOrganizationsAuthorizedTree({
        company_uuid,
        params: {
          dpc: 'announcement-to-list-organization-no-filter',
          field: 'organization_uuid,title_th', // TODO: not working field
        },
      })

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: false,
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingOrganization = false
    }
  },
  methods: {
    ...mapActions({
      fetchOrganizationsAuthorizedTree:
        'organization/fetchOrganizationsAuthorizedTree',
    }),
    handleSearchOrganization() {
      this.getOrganizationsFilterBySearch()
      this.loadingOrganization = true
    },
    getOrganizationsFilterBySearch: _.debounce(async function () {
      const organizations = await this.getOrganizationsAuthorizedTree()

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: this.selectedOrganizations.some(
            (org) => org.organization_uuid === item.organization_uuid
          ),
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)
    }, 1000),
    async getOrganizationsAuthorizedTree() {
      try {
        this.loadingOrganization = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'announcement-to-list-organization-no-filter',
            search: this.searchOrganization || '',
          },
        }

        const organizations = await this.fetchOrganizationsAuthorizedTree(
          payload
        )
        return organizations
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganization = false
      }
    },
    async handleSelectedOrganization(organization) {
      await this.setCheckOrganizationRecursive(organization)
      this.$emit('onCheckOrganization', this.selectedOrganizations)
    },
    setCheckOrganizationRecursive(organization) {
      return new Promise((resolve) => {
        if (organization.checked) {
          const index = this.selectedOrganizations.findIndex(
            (org) => org.organization_uuid === organization.organization_uuid
          )
          if (index === -1) {
            this.selectedOrganizations = [
              ...this.selectedOrganizations,
              organization,
            ]
          }
        } else {
          this.selectedOrganizations = this.selectedOrganizations.filter(
            (org) => org.organization_uuid !== organization.organization_uuid
          )
        }
        if (organization.children?.length) {
          Promise.all(
            organization.children.map((child) =>
              this.setCheckOrganizationRecursive(child)
            )
          ).then(resolve)
        } else {
          resolve()
        }
      })
    },
  },
}
</script>
